import React from 'react';
import { AppBar } from '@mui/material';

const DSAppBar = (props: React.ComponentProps<typeof AppBar>) => {
  return <AppBar {...props} />;
};

export default DSAppBar;
